import "./Login.css";
import netlifyIdentity from "netlify-identity-widget";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { Country } from "../data/types";
import { request } from "../data/utils";

type FormValues = {
  url: string;
  countryAlpha2: string;
  subCountry?: string;
};

export default function Login() {
  const handleLogin = () => {
    if (netlifyIdentity.currentUser()) {
      netlifyIdentity.logout();
    } else {
      netlifyIdentity.open();
    }
  };

  netlifyIdentity.on("login", () => window.location.reload());
  netlifyIdentity.on("logout", () => window.location.reload());

  const [countries, setCountries] = useState<Country[] | undefined>();

  useEffect(() => {
    const fetchCountries = async () => {
      const islandCountries = await request<Country[]>(
        "/.netlify/functions/get_countries",
        {
          method: "GET",
        },
      );
      setCountries(islandCountries);
    };
    fetchCountries();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = (data: FormValues, e?: React.BaseSyntheticEvent) => {
    e?.preventDefault();
    handleCreatePost(data);
  };

  const handleCreatePost = async (data: FormValues) => {
    toast.promise(createPost(data), {
      pending: "Creating post...",
      success: "Post created!",
      error: {
        render({ data }) {
          return `Error creating post: ${
            data instanceof Error ? data.message : "Unknown error"
          }`;
        },
      },
    });
  };

  const createPost = async (data: FormValues) => {
    const res = await fetch("/.netlify/functions/create_post", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      const ct = res.headers.get("content-type") || "";
      let msg = "";
      if (ct.includes("application/json")) {
        try {
          const json = await res.json();
          msg = json?.message || json?.error || JSON.stringify(json);
        } catch {
          // fallthrough
        }
      }
      if (!msg)
        msg = await res.text().catch(() => `Request failed (${res.status})`);
      throw new Error(msg || `Request failed (${res.status})`);
    }
    return res;
  };

  const countryAlpha2 = countries?.map((country) => country.alpha2);
  countryAlpha2?.sort();

  return (
    <div className="login-page">
      {netlifyIdentity.currentUser() && (
        <>
          <h4>Create new post</h4>
          <form className="form-group" onSubmit={handleSubmit(onSubmit)}>
            <input
              placeholder="URL"
              type="text"
              autoComplete="off"
              {...register("url", { required: true })}
            />
            {errors.url && <span>This field is required</span>}

            <select {...register("countryAlpha2", { required: true })}>
              {countryAlpha2?.map((value) => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
            </select>
            {errors.countryAlpha2 && <span>This field is required</span>}

            <input
              placeholder="SUBCOUNTRY"
              type="text"
              autoComplete="off"
              {...register("subCountry")}
            />
            <input type="submit" value="Submit" />
          </form>
        </>
      )}
      <div className="form-group">
        <button onClick={handleLogin}>
          {netlifyIdentity.currentUser() ? "Log Out" : "Login"}
        </button>
      </div>
    </div>
  );
}
